/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Assign_PlaceholderInputs */

const en_explorer_info_assign_placeholder = /** @type {(inputs: Explorer_Info_Assign_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select user`)
};

const fr_explorer_info_assign_placeholder = /** @type {(inputs: Explorer_Info_Assign_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selectionner un utilisateur`)
};

const de_explorer_info_assign_placeholder = /** @type {(inputs: Explorer_Info_Assign_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzer auswählen`)
};

const it_explorer_info_assign_placeholder = /** @type {(inputs: Explorer_Info_Assign_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona utente`)
};

const ru_explorer_info_assign_placeholder = /** @type {(inputs: Explorer_Info_Assign_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите пользователя`)
};

const es_explorer_info_assign_placeholder = /** @type {(inputs: Explorer_Info_Assign_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar usuario`)
};

const zh_cn2_explorer_info_assign_placeholder = /** @type {(inputs: Explorer_Info_Assign_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择用户`)
};

const ja_explorer_info_assign_placeholder = /** @type {(inputs: Explorer_Info_Assign_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ユーザーを選択`)
};

const hi_explorer_info_assign_placeholder = /** @type {(inputs: Explorer_Info_Assign_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपयोगकर्ता का चयन करें`)
};

const pt_pt2_explorer_info_assign_placeholder = /** @type {(inputs: Explorer_Info_Assign_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecionar usuário`)
};

/**
* | output |
* | --- |
* | "Select user" |
*
* @param {Explorer_Info_Assign_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_assign_placeholder = /** @type {((inputs?: Explorer_Info_Assign_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Assign_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_assign_placeholder(inputs)
	if (locale === "de") return de_explorer_info_assign_placeholder(inputs)
	if (locale === "it") return it_explorer_info_assign_placeholder(inputs)
	if (locale === "ru") return ru_explorer_info_assign_placeholder(inputs)
	if (locale === "es") return es_explorer_info_assign_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_assign_placeholder(inputs)
	if (locale === "ja") return ja_explorer_info_assign_placeholder(inputs)
	if (locale === "hi") return hi_explorer_info_assign_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_assign_placeholder(inputs)
	return en_explorer_info_assign_placeholder(inputs)
});